import Navbar from "@/components/feature/Navbar";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import BrandValueSection from "./components/BrandValueSection";
import ComparisonSection from "./components/ComparisonSection";
import TrustSection from "./components/TrustSection";
import BlogPreviewSection from "./components/BlogPreviewSection";
import Footer from "@/components/feature/Footer";

const siteUrl = typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env.VITE_SITE_URL : '';
const domain = siteUrl || 'https://oopbuyspreadsheets.makeup';

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "OOPBuy Spreadsheet Guide",
  "url": domain,
  "description": "The smartest way to organize and optimize online shopping with spreadsheet-based product comparison, structured data, and expert guides.",
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": domain + "/search?q={search_term_string}"
    },
    "query-input": "required name=search_term_string"
  }
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <main>
        <Navbar />
        <Hero />
        <CategorySection />
        <BrandValueSection />
        <ComparisonSection />
        <TrustSection />
        <BlogPreviewSection />
        <Footer />
      </main>
    </>
  );
}